import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../../environments/environment';
import { SessionsListResponse } from '../models/active-devices.model';

/**
 * HTTP surface for active devices.
 *
 * The session list itself is fetched from the user-management API (paged,
 * with rich device metadata). The realtime websocket store only supplies
 * the *current* socket / session identity so the UI can mark "this device"
 * in the API-provided list.
 */
@Injectable({
  providedIn: 'root',
})
export class ActiveDevicesService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.userManagementApiUrl;

  listSessions(params: {
    page: number;
    pageSize: number;
  }): Observable<SessionsListResponse> {
    const { page, pageSize } = params;
    const paramsHttp = new HttpParams()
      .set('page', String(page))
      .set('limit', String(pageSize));
    return this.http.get<SessionsListResponse>(
      `${this.apiUrl}/api/auth/v1/devices`,
      { params: paramsHttp }
    );
  }

  deleteSession(sessionId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/api/auth/v1/sessions/${sessionId}`
    );
  }

  terminateOtherSessions(): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/api/auth/v1/sessions/terminate-others`,
      {}
    );
  }
}
